let global_ip = (()=>{if (window && window.MLMSoft && window.MLMSoft.ui_proxy && window.MLMSoft.ui_proxy.ip) return window.MLMSoft.ui_proxy.ip; return null})();
let global_subPath = (()=>{if (window && window.MLMSoft && window.MLMSoft.ui_proxy && window.MLMSoft.ui_proxy.subPath) return window.MLMSoft.ui_proxy.subPath; return null})();
let global_port = (()=>{if (window && window.MLMSoft && window.MLMSoft.ui_proxy && window.MLMSoft.ui_proxy.port) return window.MLMSoft.ui_proxy.port; return null})();
module.exports = {
    client_id: 'CLIENT_ID',
    client_secret: 'null',
    ip_proxy: global_ip,
    subPath: global_subPath || '',
    port_proxy: global_port,
    refresh_token: 'token',
    auth: 'auth/login',
    auth_mail_code: 'auth/login_mail',
    restricted_area: 'restrictedArea',
    localization: {
        ip: global_ip,
        port: global_port,
        subPath: global_subPath || '',
        getPath: 'localization'
    },
    emptyPerson: 'https://w.easy-bizzi.com/images/empty.png', //image for person that hasn't avatar
    cacheTime: 60, // cache time in seconds
    requestTimeout: 90000 // client-> proxy timeout in ms
};
